<template>
  <section>
    <p v-if="!withoutLabel"><b>{{data.label}}: </b></p>
    <p>{{ data.displayValue }}</p>
  </section>
</template>
<script>
export default {
  name: 'idUserDataCustomFieldValue',
  props: {
    data: {},
    withoutLabel: {
      type: Boolean,
      default: false
    }
  },
  methods: {
  }
}
</script>
